// Validated environment access for the auth app. Fails fast in production builds.
//
// The auth app is intentionally minimal: it only needs to talk to Supabase
// Auth + know which other origins are allowed return-to targets. Allowed
// return-to origins live in `lib/returnTo.ts` so they can be diffed without
// touching env handling.

export interface AuthEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  /**
   * Public URL this auth site is served from. Used to build absolute
   * `emailRedirectTo` / `redirectTo` values that bounce the user back to
   * THIS site after the verification email click (the auth SPA then does
   * the actual hand-off to whichever B2B app the user was originating
   * from). Defaults to `window.location.origin` so a developer running
   * `pnpm --filter @pc/auth dev` on http://localhost:5180 still gets a
   * working flow.
   */
  authUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required env var ${name}. Set it in apps/auth/.env.local or in the Netlify site settings.`,
    );
  }
  return value;
}

function optional(value: string | undefined): string | null {
  if (!value || value.length === 0) return null;
  return value;
}

export const env: AuthEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL as string),
  supabaseAnonKey: required(
    'VITE_SUPABASE_ANON_KEY',
    import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  ),
  authUrl:
    optional(import.meta.env.VITE_AUTH_PUBLIC_URL as string | undefined) ??
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5180'),
};
